import useIsMobile from '@/hooks/useIsMobile';
import { useReportingToolsStore } from '@/pages/reporting-tools/store/useReportingToolsStore';
import { useSuspenseQuery } from '@apollo/client';
import {
  FETCH_REPORTING_TOOLS_COMPASS_EXERCISE_OVER_TIME,
  FetchReportingToolsCompassExerciseOverTimeQuery,
  FetchReportingToolsCompassExerciseOverTimeQueryVariables,
  CompassExerciseOverTime,
} from '@edwin-group/cj-graphql';
import { ChartData } from 'chart.js';
import { useDeferredValue, useEffect, useState } from 'react';
import { parseCompassExercisesOverTime } from '../chart/parse';

export const useCompassExercisesOverTime = () => {
  const [lineData, setLineData] = useState<ChartData<'line'>>({ datasets: [] });
  const { isMobile } = useIsMobile();

  const filtersStore = useReportingToolsStore((state) => state.filters);
  const filters = useDeferredValue(filtersStore);
  const isPending = filtersStore !== filters;

  const { data, error } = useSuspenseQuery<
    FetchReportingToolsCompassExerciseOverTimeQuery,
    FetchReportingToolsCompassExerciseOverTimeQueryVariables
  >(FETCH_REPORTING_TOOLS_COMPASS_EXERCISE_OVER_TIME, {
    fetchPolicy: 'cache-and-network',
    variables: {
      schoolDocumentIds: filters.schoolDocumentIds,
      academicYear: filters.academicYear,
    },
    errorPolicy: 'all',
  });

  useEffect(() => {
    if (data) {
      const reportData = data.fetchReportingToolsCompassExerciseOverTime
        ?.compassExerciseOverTime as CompassExerciseOverTime[];
      setLineData(parseCompassExercisesOverTime(reportData, filters.academicYear));
      return;
    }

    setLineData({ datasets: [] });
  }, [data, filters.academicYear]);

  return { lineData, isMobile, error, isPending };
};
